<template>
  <a
    role="button"
    tabindex="0"
    class="text-reset text-decoration-none ms-1"
    style="cursor: pointer"
    data-bs-toggle="modal"
    data-bs-target="#citesModal"
    aria-label="About CITES-protected woods"
    ><font-awesome-icon icon="fa-solid fa-circle-info"
  /></a>
</template>
<script lang="ts">
export default {
  name: "CitesInfoComponent",
};
</script>
